import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@material-ui/icons/Clear';
import styled from 'styled-components';
import { Field } from 'formik';
import { get, join, startCase } from 'lodash';
import Yup from 'yup';
import { formatDate } from '../../../util/helpers';
import { TextFieldWrapper } from '../../common';

const DATE = 'date';

const getDateFieldName = (paths, fieldName) => join([...paths, fieldName], '.');

const StyledIconButton = styled(IconButton)`
  display: none;
  @supports (-webkit-overflow-scrolling: touch) {
    display: block;
  }
`;

class DateField extends React.Component {
  setDateValue = () => {
    const { fieldName, paths, setFieldValue, values } = this.props;
    const dateFieldName = getDateFieldName(paths, fieldName);
    const date = get(values, dateFieldName);

    if (!!date) setFieldValue(dateFieldName, formatDate(date));
  };

  componentDidMount() {
    this.setDateValue();
  }

  render() {
    const {
      fieldName,
      label,
      paths,
      required,
      setFieldValue,
      values,
    } = this.props;
    const dateFieldName = getDateFieldName(paths, fieldName);
    const dateValue = get(values, dateFieldName);

    const clearDateValue = () => {
      setFieldValue(dateFieldName, '');
    };

    return (
      <Field
        component={TextFieldWrapper}
        id={fieldName}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {dateValue && (
                <StyledIconButton onClick={clearDateValue}>
                  <ClearIcon />
                </StyledIconButton>
              )}
            </InputAdornment>
          ),
        }}
        label={startCase(label)}
        name={dateFieldName}
        paths={[...paths, fieldName]}
        required={required}
        type="date"
      />
    );
  }
}

DateField.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  fieldName: PropTypes.string,
  label: PropTypes.string,
  paths: PropTypes.array,
  required: PropTypes.bool,
};

const defaultConfig = {
  required: false,
  fieldName: DATE,
  label: 'Date',
};

DateField.defaultProps = {
  ...defaultConfig,
  paths: [],
};

export default DateField;

export function getDateValidation(config = defaultConfig) {
  const { fieldName, label, required } = config;
  const dateSchema = Yup.date().typeError(
    'Date format: MM/DD/YYYY or YYYY-MM-DD',
  );

  return {
    [fieldName]: required
      ? dateSchema.required(`${label} is required.`)
      : dateSchema,
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/form/DateField.js